import Cart from "cart-store";

class EmduAfterpayCart extends HTMLElement {
    connectedCallback() {
        queueMicrotask(() => {
            if (!this.isConnected) return;
            this.placement = this.querySelector('square-placement[data-page-type="cart"]');
            if (!this.placement) return;
            if (this.unsubscribe) this.unsubscribe();
            this.update(Cart.getState().cart);
            this.unsubscribe = Cart.subscribe((state, previousState) => {
                if (state.cart !== previousState.cart) this.update(state.cart);
            });
        });
    }

    update(cart) {
        const cents = Number(cart?.total_price || 0);
        const hasItems = Number(cart?.item_count || 0) > 0;
        this.hidden = !hasItems || !Number.isFinite(cents) || cents <= 0;
        if (this.hidden) return;
        const amount = (cents / 100).toFixed(2);
        const skus = (cart.items || []).map(item => item.sku || "").filter(Boolean).join(",");
        if (this.placement.dataset.amount !== amount) this.placement.dataset.amount = amount;
        if (cart.currency && this.placement.dataset.currency !== cart.currency) {
            this.placement.dataset.currency = cart.currency;
        }
        if (this.placement.dataset.itemSkus !== skus) this.placement.dataset.itemSkus = skus;
    }

    disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
    }
}

if (!customElements.get("emdu-afterpay-cart")) {
    customElements.define("emdu-afterpay-cart", EmduAfterpayCart);
}

if (!document.querySelector('script[src="https://js.squarecdn.com/square-marketplace.js"]')) {
    const providerScript = document.createElement("script");
    providerScript.src = "https://js.squarecdn.com/square-marketplace.js";
    providerScript.async = true;
    document.head.append(providerScript);
}
